import { render, staticRenderFns } from "./last_commit.vue?vue&type=template&id=16f25d1b"
import script from "./last_commit.vue?vue&type=script&lang=js"
export * from "./last_commit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports